import {FooterLink} from "../../../../types.ts";

export default [
  {
    name: 'Security & Privacy',
    href: '/security-privacy',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'privacy',
  },
  {
    name: 'Terms & Conditions',
    href: '/terms',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'terms & conditions',
  },
  {
    name: 'Protect yourself online',
    href: '/safe-job-searching',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'protect yourself online',
  },
  {
    name: 'Contact',
    href: '/contact-us',
    rel: 'nofollow',
    analytics: 'navigation_pressed',
    linkText: 'contact us',
  },
] as FooterLink[];
